export class FileUtil {
  static normalizeBase64(b64: string): string {
    // Convierte URL-safe a estándar
    b64 = b64.replace(/-/g, '+').replace(/_/g, '/');
    // Añade padding (=) si falta
    const pad = b64.length % 4;
    return pad ? b64 + '='.repeat(4 - pad) : b64;
  }

  static decodeBase64(b64: string): string {
    const norm = this.normalizeBase64(b64);
    // atob devuelve string binario (latin1)
    const bin = globalThis.atob(norm);
    // Convierte a bytes
    const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
    // Decodifica UTF-8 seguro (acentos, emojis, etc.)
    return new TextDecoder('utf-8').decode(bytes);
  }

  static removeExtension(filename: string): string {
    const lastDot = filename.lastIndexOf('.');
    return lastDot === -1 ? filename : filename.substring(0, lastDot);
  }
}
